import { useState } from "react";
import { Modal, Row, Form, Col, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import toastService from "../../_services/toastService";
import MessageModal from "../_components/MessageModal";
import SatAPI from "../../_services/sat";

const api = SatAPI();

function RemoveModal({ data = {}, hideModal }) {
  const snapshot = useSelector(state => state.snapshot.fileName);

  const [messageModal, setMessageModal] = useState(null);

  const openMessageModal = (title, message) => {
    setMessageModal(
      <MessageModal
        hideModal={() => setMessageModal(null)}
        title={title}
        message={message}
        icon="fas fa-exclamation-triangle"
      />
    );
  };

  const onFormSubmit = async e => {
    e.preventDefault();

    const allocations = await api.getBudgetSourceAllocations(snapshot);
    const activeAllocations = allocations.filter(a => a.budgetSourceID === data.ID && Number(a.amountFTE) > 0);

    if (activeAllocations.length > 0) {
      openMessageModal(
        "Allocaties nog ingevuld",
        `Een budgetbron kan alleen verwijderd worden als er geen allocaties meer aan gekoppeld zijn. De budgetbron '${data.name}' heeft nog ${activeAllocations.length} actieve allocatie(s) in de contingentverdeling. Ga naar de pagina Contingentverdeling, zet alle waarden in de kolom van deze budgetbron op 0 of leeg en sla op. Daarna kan je de budgetbron verwijderen.`
      );
      return;
    }

    try {
      await api.deleteBudgetSource(data.ID);
      toastService.send({ title: "Verwijderd", message: "Budgetbron is verwijderd" });
      hideModal();
    } catch (error) {
      toastService.send({ title: "An error occured", message: error });
    }
  };

  return (
    <Modal
      show
      onHide={() => {
        hideModal();
      }}
      backdrop="static"
      keyboard={false}
      centered
      size="lg">
      {messageModal}
      <Modal.Header closeButton>
        <Modal.Title>Budgetbron verwijderen?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xs={12}>
            <Form onSubmit={onFormSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Ben je zeker dat je de budgetbron <span className="font-bold">{data.name}</span> wilt verwijderen?</Form.Label>
              </Form.Group>

              <Button variant="danger" type="submit" disabled={snapshot}>
                <span>
                  <i className="far fa-trash" />
                  &nbsp;Verwijder
                </span>
              </Button>
            </Form>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export default RemoveModal;
